import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import Slices from "../slices";
import { Redirect } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";

export default function PrismicPage(props) {
  const dispatch = useDispatch();

  const [extraClass, setExtraClass] = useState(false);
  const id = props.location.pathname.substr(1);

  const pageLoading = useSelector((state) =>
    get(state, "prismic.custom_page.loading", true),
  );
  const page = useSelector((state) =>
    get(state, "prismic.custom_page.data", false),
  );

  const slices = get(page, "body");

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_BY_UID",
      key: "custom_page",
      id,
    });
  }, [dispatch, id]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setExtraClass(false);
    setTimeout(() => {
      setExtraClass("yas");
    }, 200);
  }, [pageLoading]);

  if (pageLoading) {
    return (
      <CircularProgress
        style={{
          position: "fixed",
          color: "white",
          top: "calc(50% - 25px)",
          left: "calc(50% - 25px)",
          width: "50px",
          height: "50px",
        }}
      />
    );
  }

  if (!page) {
    return <Redirect to={"/404"} />;
  }

  return (
    !pageLoading &&
    page && (
      <div className={`animation ${extraClass && extraClass}`}>
        <Slices slices={slices}></Slices>
      </div>
    )
  );
}
